import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pim-feedback-panel col border-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "pim-feedback-panel-title me-5" }, "Feedback", -1)
const _hoisted_3 = { class: "pim-feedback-panel border position-relative p-1 mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center mt-0 mb-3"
}
const _hoisted_5 = { class: "me-3" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex align-items-center mt-0 mb-3"
}
const _hoisted_7 = { class: "me-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_GenericFormWrapper, {
          pageUI: _ctx.pageUI,
          submitData: _ctx.submitPimFeedback,
          submitButtonTranslationKey: "send",
          buttonClass: "btn-sm",
          class: "mt-3 mb-3"
        }, {
          content: _withCtx(({errors}) => [
            (_ctx.fieldCode != null && _ctx.isShowFieldCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.$t('field')), 1),
                  (!_ctx.isGeneralRemark)
                    ? (_openBlock(), _createBlock(_component_InputSelect, {
                        key: 0,
                        modelValue: _ctx.localFieldCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFieldCode) = $event)),
                        options: _ctx.enumPimProductFieldCode,
                        name: "field-code",
                        errors: errors,
                        disabled: true
                      }, null, 8, ["modelValue", "options", "errors"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_InputTextEditor, {
              label: _ctx.$t('remark'),
              modelValue: _ctx.localFeedback.remarks,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFeedback.remarks) = $event)),
                _ctx.checkFormDataChanged
              ],
              name: "feedbackRemarks",
              class: "mb-3",
              mode: "bare",
              height: 200,
              errors: errors
            }, null, 8, ["label", "modelValue", "errors", "onUpdate:modelValue"]),
            (!_ctx.isGeneralRemark && _ctx.fieldCode === 'TEXT_FRAGMENT')
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  label: _ctx.$t('title'),
                  modelValue: _ctx.localFeedback.proposed_new_fragment_title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFeedback.proposed_new_fragment_title) = $event)),
                  name: "feedbackTitle",
                  errors: errors
                }, null, 8, ["label", "modelValue", "errors"]))
              : _createCommentVNode("", true),
            (!_ctx.isGeneralRemark)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.$t('fragmentCategoryCodeProposed')), 1),
                  (!_ctx.isGeneralRemark)
                    ? (_openBlock(), _createBlock(_component_InputSelect, {
                        key: 0,
                        modelValue: _ctx.localFeedback.proposed_new_fragment_name_code,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFeedback.proposed_new_fragment_name_code) = $event)),
                        options: _ctx.enumFragmentNameCode,
                        name: _ctx.$t('fragmentCategoryCode'),
                        selectText: _ctx.$t('selectText'),
                        "can-clear": "",
                        errors: errors
                      }, null, 8, ["modelValue", "options", "name", "selectText", "errors"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isGeneralRemark)
              ? (_openBlock(), _createBlock(_component_InputTextEditor, {
                  key: 3,
                  label: _ctx.$t('proposedNewContent'),
                  modelValue: _ctx.localFeedback.proposed_new_value,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFeedback.proposed_new_value) = $event)),
                    _ctx.checkFormDataChanged
                  ],
                  name: "feedbackNewValue",
                  class: "mb-3",
                  errors: errors
                }, null, 8, ["label", "modelValue", "errors", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          buttons: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-primary",
              type: "button",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitPimFeedbackCancel()), ["prevent"]))
            }, _toDisplayString(_ctx.$t('cancel')), 1)
          ]),
          _: 1
        }, 8, ["pageUI", "submitData"])
      ])
    ])
  ]))
}